<template>
  <a-spin :spinning="loading">
    <a-row>
      <a-card hoverable>
        <a-card-meta :title="fillOut.person_name || 'ANÓNIMO'"
                     :description="fillOut.id_person">
          <a-avatar
            slot="avatar"
            :src="profileSrc"
          />
        </a-card-meta>
        <template v-if="biodata && $getConfigValue('MOSTRAR_BOTON_FINALIZAR_FORMULARIOS', 'NO') === 'NO'" class="ant-card-actions" slot="actions">
          <a-progress style="width: 80%" :strokeColor="{
        '0%': '#108ee9',
        '100%': '#87d068',
      }" :percent="parseFloat(fillOut.porcentaje)" status="active"/>
        </template>
      </a-card>
    </a-row>
    <a-row v-if="$getConfigValue('MENSAJE_FORMULARIO')">
      &nbsp;
      <a-alert type="info" showIcon>
            <span slot="message" v-html="$getConfigValue('MENSAJE_FORMULARIO')">
            </span>
      </a-alert>
    </a-row>
    <a-row>
      <a-form-model ref="mainForm" :model="respuestas" v-bind="fiOptions">
        <a-collapse v-if="fillOut.form" v-model="activeHeaders">
          <a-collapse-panel v-for="header in fillOut.form.active_headers" :key="header.id.toString()"
                            :header="header.name">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions" v-for="component in header.active_components">

                <a-form-model-item :label="component.label" :prop="component.name"
                                   :hasFeedback="component.h_component_type !== 'CHECKBOX' && component.h_component_type !== 'RADIO'"
                                   :rules="[{required: component.required, message: `El campo ${component.label} es requerido.`}]">

                  <template v-if="component.h_component_type === 'LOV_SQL'">
                    <form-model-dropdown style="width: 100%"
                                         v-model="respuestas[component.name]"
                                         endpoint="forms_components/sql_lov_param_values"
                                         :cache="false"
                                         :params="{...respuestas, id_param: component.id}"
                                         @change="propChanged($event, component)"
                                         :disabled="loadingBtn['comp_'+component.id]"
                                         :loading="loadingBtn['comp_'+component.id]">
                    </form-model-dropdown>
                  </template>

                  <a-select v-else-if="component.h_component_type === 'LOV'"
                            v-model="respuestas[component.name]"
                            style="width: 100%"
                            @change="propChanged($event, component)"
                            :disabled="loadingBtn['comp_'+component.id]"
                            :loading="loadingBtn['comp_'+component.id]">
                    <a-select-option :value="option.value" v-for="option in component.options">
                      {{option.label}}
                    </a-select-option>
                  </a-select>
                  <a-input-number v-else-if="component.h_component_type === 'NUMBER'"
                                  v-model="respuestas[component.name]"
                                  style="width: 100%"
                                  @blur="propChanged(respuestas[component.name], component)"
                                  :disabled="loadingBtn['comp_'+component.id]"
                                  :loading="loadingBtn['comp_'+component.id]"></a-input-number>

                  <a-date-picker v-else-if="component.h_component_type === 'DATE'"
                                 v-model="respuestas[component.name]"
                                 style="width: 100%"
                                 @change="propChanged($event, component)"
                                 :disabled="loadingBtn['comp_'+component.id]"
                                 :loading="loadingBtn['comp_'+component.id]"></a-date-picker>
                  <a-checkbox-group v-model="respuestas[component.name]"
                                    v-else-if="component.h_component_type === 'CHECKBOX'"
                                    @change="propChanged($event, component)">

                    <div v-for="option in component.options">
                      <a-checkbox :value="option.value">
                        {{option.label}}
                      </a-checkbox>
                    </div>
                  </a-checkbox-group>
                  <a-radio-group v-model="respuestas[component.name]"
                                 v-else-if="component.h_component_type === 'RADIO'"
                                 @change="(e) => propChanged(e.target.value, component)">
                    <div v-for="option in component.options">
                      <a-radio :value="option.value">
                        {{option.label}}
                      </a-radio>
                    </div>
                  </a-radio-group>
                  <a-textarea v-else-if="component.h_component_type === 'TEXTAREA'"
                              auto-size
                              v-model="respuestas[component.name]"
                              @blur="(e) => propChanged(respuestas[component.name], component)"
                              :disabled="loadingBtn['comp_'+component.id]"
                              :loading="loadingBtn['comp_'+component.id]"></a-textarea>
                  <a-input v-else
                           v-model="respuestas[component.name]"
                           @blur="(e) => propChanged(respuestas[component.name], component)"
                           :disabled="loadingBtn['comp_'+component.id]"
                           :loading="loadingBtn['comp_'+component.id]"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-collapse-panel>
        </a-collapse>
      </a-form-model>
    </a-row>
    <br>
    <template v-if="biodata && $getConfigValue('MOSTRAR_BOTON_FINALIZAR_FORMULARIOS') === 'SI'">
      <a-row v-if="mensajeCompletarParaFinalizarHtml">
        &nbsp;
        <a-alert type="info" showIcon>
          <span slot="message" v-html="mensajeCompletarParaFinalizarHtml"></span>
        </a-alert>
      </a-row>
      <br>
      <div style="text-align: right">
        <a-button
          type="primary"
          :disabled="!canFinalizeForm"
          @click="onFinalizarClick">
          Finalizar
        </a-button>
      </div>
    </template>
  </a-spin>
</template>
<script>
  import { Modal } from 'ant-design-vue'
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import DateUtils from '@/util/DateUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  /**
   * Variables de configuracion
   *
   * Modo estricto (validación obligatorios, botón deshabilitado, modal de éxito, aviso HTML):
   * Solo aplica si coinciden formulario Y nombre de cliente. Si no aplica, Finalizar se comporta como antes
   * (sin validación extra ni modal).
   *
   * - FINALIZAR_ENCUESTA_STRICT_ID_FORM: id(s) del formulario, separados por coma (ej. "12" o "12,34").
   *   Se compara con fillOut.form.id (o id_form si existiera en la respuesta).
   * - FINALIZAR_ENCUESTA_CLIENTE: nombre/código del cliente para el cual aplica el modo estricto
   *   (ej. "SEVICOL"). Debe coincidir (sin distinguir mayúsculas) con el nombre actual del cliente
   *   en configuraciones: primero CLIENTE_GBPO, si no hay valor en NOMBRE_CLIENTE_CORTO, luego SIGLA_CLIENTE.
   *
   * Mensajes (solo en modo estricto):
   * - MENSAJE_ENCUESTA_COMPLETAR_PARA_FINALIZAR: texto/HTML informativo.
   * - MENSAJE_ENCUESTA_DILIGENCIADA_TITULO: título del modal de éxito.
   * - MENSAJE_ENCUESTA_DILIGENCIADA_EXITO: cuerpo del modal de éxito.
   */

  export default {
    data () {
      return {
        fiOptions: {
          'label-col': {span: 24},
          'wrapper-col': {span: 24}
        },
        loading: false,
        fillOutId: '',
        biodata: false,
        fillOut: {},
        activeHeaders: [],
        respuestas: {},
        loadingBtn: {},
        componentTypes: {},
        defaultPicture: require('./../../assets/anon_profile.png'),
        profileSrc: require('./../../assets/anon_profile.png')
      }
    },
    mounted () {
      this.fillOutId = this.$route.query.fillOutId
      this.biodata = this.$route.query.formulario_desde_biodata
      if (JsUtils.isEmpty(this.fillOutId)) {
        this.$router.push('404')
      } else {
        this.httpClient = new HttpUtil('forms_fillout')
        this.loadForm()
      }
    },
    methods: {
      loadForm () {
        this.loading = true
        this.httpClient.show(this.fillOutId, (response) => {
          this.processForm(response)
          this.loadEmployPicture(response.data.id_person)
        }, () => {
          this.$router.push('404')
        }).then(() => {
          this.loading = false
        })
      },
      propChanged (e, component) {
        if (!JsUtils.isEmpty(e)) {
          let request = {
            id_component: component.id,
            id_fillout: this.fillOutId
          }
          switch (component.h_component_type) {
            case 'DATE':
              request.value = DateUtils.forBackEnd(e)
              break
            case 'CHECKBOX':
              let result = ''
              e.map(v => {
                result += (v + ',')
              })
              request.value = (result + 'XX').replace(',XX', '')
              break
            case 'LOV':
            case 'LOV_SQL':
            case 'NUMBER':
            case 'TEXT':
            case 'TEXTAREA':
            case 'RADIO':
              request.value = e
              break
          }

          this.loadingBtn['comp_' + component.id] = true
          this.$forceUpdate()

          this.httpClient.getInstance().post('forms_fillout_resp', request)
            .then(response => {
              this.fillOut.porcentaje = response.data.porcentaje
              Mensajes.success('Correcto', 'Guardado correctamente')
            })
            .catch(error => {
              let msj = 'Error desconocido, contacte al administrador'
              if (error.response.data.message) {
                msj = error.response.data.message
              }
              Mensajes.error('Error', msj)
            })
            .then(() => {
              this.loadingBtn['comp_' + component.id] = false
              this.$forceUpdate()
            })
        }
      },
      getType (tipoOiginal) {
        switch (tipoOiginal) {
          case 'NUMBER':
            return 'number'
          case 'CHECKBOX':
            return 'array'
          /*
          case 'DATE':
          case 'LOV':
          case 'TEXT':
          case 'TEXTAREA':
          case 'RADIO':
            return 'any'
          */
        }
        return 'any'
      },
      processForm (response) {
        this.fillOut = response.data
        this.activeHeaders.splice(0, this.activeHeaders.length)
        this.loadingBtn = {}
        this.componentTypes = {}
        this.fillOut.form.active_headers && this.fillOut.form.active_headers.map(header => {
          header.active_components && header.active_components.map(comp => {
            comp['name'] = 'comp_' + comp.id
            this.componentTypes['comp_' + comp.id] = comp.h_component_type
            this.respuestas['comp_' + comp.id] = null
          })
          this.activeHeaders.push(header.id.toString())
        })

        this.processResponses()
      },
      processResponses () {
        this.$refs.mainForm.resetFields()
        let resps = {}
        this.fillOut.responses.map(r => {
          if (this.componentTypes['comp_' + r.id_component] === 'CHECKBOX') {
            resps['comp_' + r.id_component] = r.value.split(',')
          } else if (this.componentTypes['comp_' + r.id_component] === 'DATE') {
            resps['comp_' + r.id_component] = moment(r.value)
          } else if (this.componentTypes['comp_' + r.id_component] === 'NUMBER') {
            resps['comp_' + r.id_component] = parseFloat(r.value)
          } else {
            resps['comp_' + r.id_component] = r.value
          }
        })

        this.respuestas = resps
      },
      loadEmployPicture (idPerson) {
        this.profileSrc = this.defaultPicture
        this.httpClient.getInstance().get('picture_service/render/profile/' + idPerson, {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            let blob = new Blob([response.data], {type: response.headers['content-type']})
            this.profileSrc = window.URL.createObjectURL(blob)
          })
          .catch(() => {})
      },
      /**
       * Valida que el valor cumpla obligatoriedad según el tipo de componente.
       *
       * @param {Object} component - Componente del formulario.
       * @param {*} value - Valor en respuestas[component.name].
       * @returns {boolean}
       */
      isRequiredValueSatisfied (component, value) {
        if (!component.required) {
          return true
        }
        const tipo = component.h_component_type
        if (tipo === 'NUMBER') {
          return value !== null && value !== undefined && typeof value === 'number' && !Number.isNaN(value)
        }
        if (tipo === 'DATE') {
          if (value === null || value === undefined) {
            return false
          }
          if (typeof moment !== 'undefined' && moment.isMoment && moment.isMoment(value)) {
            return value.isValid()
          }
          return !JsUtils.isEmpty(value)
        }
        if (tipo === 'CHECKBOX') {
          return Array.isArray(value) && value.length > 0
        }
        return !JsUtils.isEmpty(value)
      },
      /**
       * Recorre componentes activos y comprueba obligatorios.
       *
       * @returns {boolean}
       */
      areAllRequiredFieldsFilled () {
        if (!this.fillOut.form || !this.fillOut.form.active_headers) {
          return false
        }
        for (let h = 0; h < this.fillOut.form.active_headers.length; h++) {
          const header = this.fillOut.form.active_headers[h]
          const components = header.active_components || []
          for (let c = 0; c < components.length; c++) {
            const component = components[c]
            const value = this.respuestas[component.name]
            if (!this.isRequiredValueSatisfied(component, value)) {
              return false
            }
          }
        }
        return true
      },
      onFinalizarClick () {
        if (!this.isEncuestaFinalizeStrict) {
          this.redirectFinalizarLegacy()
          return
        }
        if (!this.$refs.mainForm) {
          Mensajes.error('Error', 'No se pudo validar el formulario.')
          return
        }
        this.$refs.mainForm.validate((valid) => {
          if (!valid) {
            Mensajes.warning(
              'Formulario incompleto',
              'Por favor diligencie todos los campos obligatorios antes de finalizar.'
            )
            return
          }
          const tituloExito = this.resolveMensajeDiligenciadaTitulo()
          const mensajeExito = this.resolveMensajeDiligenciadaExito()
          const routeFinal = { name: 'Self Service Dashboard' }
          Modal.success({
            title: tituloExito,
            content: mensajeExito,
            okText: 'Aceptar',
            onOk: () => {
              this.$router.push(routeFinal)
            }
          })
        })
      },
      resolveMensajeDiligenciadaTitulo () {
        const fromConfig = this.$getConfigValue('MENSAJE_ENCUESTA_DILIGENCIADA_TITULO')
        if (!JsUtils.isEmpty(fromConfig)) {
          return fromConfig
        }
        return 'Encuesta enviada'
      },
      resolveMensajeDiligenciadaExito () {
        const fromConfig = this.$getConfigValue('MENSAJE_ENCUESTA_DILIGENCIADA_EXITO')
        if (!JsUtils.isEmpty(fromConfig)) {
          return fromConfig
        }
        return 'La encuesta ha sido diligenciada y guardada correctamente.'
      },
      /**
       * Finalizar sin validación ni modal (comportamiento previo al modo estricto).
       */
      redirectFinalizarLegacy () {
        this.$router.push({ name: 'Self Service Dashboard' })
      },
      /**
       * Obtiene el id del formulario en la respuesta del fillout.
       *
       * @returns {string|null}
       */
      getCurrentFormId () {
        if (!this.fillOut.form) {
          return null
        }
        const raw = this.fillOut.form.id !== undefined && this.fillOut.form.id !== null
          ? this.fillOut.form.id
          : this.fillOut.form.id_form
        if (raw === undefined || raw === null) {
          return null
        }
        return String(raw)
      },
      /**
       * Indica si el id del formulario actual está en FINALIZAR_ENCUESTA_STRICT_ID_FORM.
       *
       * @returns {boolean}
       */
      matchesStrictFormFilter () {
        const raw = this.$getConfigValue('FINALIZAR_ENCUESTA_STRICT_ID_FORM')
        if (JsUtils.isEmpty(raw)) {
          return false
        }
        const currentId = this.getCurrentFormId()
        if (currentId === null) {
          return false
        }
        const ids = String(raw).split(',').map(function (s) {
          return s.trim()
        }).filter(function (x) {
          return x.length > 0
        })
        for (let i = 0; i < ids.length; i++) {
          if (ids[i] === currentId) {
            return true
          }
        }
        return false
      },
      /**
       * Normaliza nombre de cliente para comparar (trim + mayúsculas).
       *
       * @param {*} value - Valor a normalizar.
       * @returns {string}
       */
      normalizeNombreCliente (value) {
        if (value === undefined || value === null) {
          return ''
        }
        return String(value).trim().toUpperCase()
      },
      /**
       * Nombre/código corto del cliente actual desde configuraciones.
       *
       * @returns {string|null}
       */
      resolveNombreClienteActual () {
        const candidatos = ['CLIENTE_GBPO', 'NOMBRE_CLIENTE_CORTO', 'SIGLA_CLIENTE']
        for (let i = 0; i < candidatos.length; i++) {
          const clave = candidatos[i]
          const valor = this.$getConfigValue(clave)
          if (!JsUtils.isEmpty(valor)) {
            return String(valor)
          }
        }
        return null
      },
      /**
       * Indica si el nombre del cliente actual coincide con FINALIZAR_ENCUESTA_CLIENTE (ej. SEVICOL).
       *
       * @returns {boolean}
       */
      matchesStrictClientFilter () {
        const esperado = this.$getConfigValue('FINALIZAR_ENCUESTA_CLIENTE')
        if (JsUtils.isEmpty(esperado)) {
          return false
        }
        const actual = this.resolveNombreClienteActual()
        if (actual === null) {
          return false
        }
        return this.normalizeNombreCliente(actual) === this.normalizeNombreCliente(esperado)
      }
    },
    computed: {
      colOptions () {
        return {xs: 24, sm: 24 / this.fillOut.form.num_cols}
      },
      /**
       * Valida obligatorios, deshabilita botón y modal de éxito solo para el par cliente+formulario configurado.
       *
       * @returns {boolean}
       */
      isEncuestaFinalizeStrict () {
        return this.matchesStrictFormFilter() && this.matchesStrictClientFilter()
      },
      canFinalizeForm () {
        if (!this.biodata || this.loading) {
          return false
        }
        if (this.$getConfigValue('MOSTRAR_BOTON_FINALIZAR_FORMULARIOS') !== 'SI') {
          return false
        }
        if (!this.isEncuestaFinalizeStrict) {
          return true
        }
        return this.areAllRequiredFieldsFilled()
      },
      mensajeCompletarParaFinalizarHtml () {
        if (!this.biodata || this.$getConfigValue('MOSTRAR_BOTON_FINALIZAR_FORMULARIOS') !== 'SI') {
          return ''
        }
        if (!this.isEncuestaFinalizeStrict) {
          return ''
        }
        const fromConfig = this.$getConfigValue('MENSAJE_ENCUESTA_COMPLETAR_PARA_FINALIZAR')
        if (!JsUtils.isEmpty(fromConfig)) {
          return fromConfig
        }
        return 'Debe diligenciar todas las preguntas obligatorias de la encuesta para habilitar el botón <strong>Finalizar</strong>.'
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Formularios/FormFillout.vue